import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../components/atoms/custom-select';
import { APIHeader } from '../index';
import { userInfo } from '../reducers/user-info/slice';
import { errorNotification } from '../reducers/handle-api-status/slice';

// To achieve the Language Change funcationality
const LanguageChange = props => {
  const { userInfoData } = props;
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();

  //custom style for language drop-down
  const Styles = {
    control: styles => {
      return {
        ...styles,
        border: '1px solid black',
        // This line disables the blue border
        boxShadow: 'none',
        margin: '10px 0px',
      };
    },
    singleValue: base => {
      return { ...base, color: 'black' };
    },
    dropdownIndicator: base => ({
      ...base,
      color: 'black',
    }),
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: 'black',
      };
    },
    input: defaultStyles => {
      return {
        ...defaultStyles,
        color: 'black',
      };
    },
    menu: defaultStyles => ({
      ...defaultStyles,
      zIndex: 9999,
      height: 'auto',
      top: 'auto',
      bottom: '100%',
    }),
    menuPortal: provided => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  //options for langauge drop-down
  const languageOptions = [
    {
      label: 'English',
      value: 'English',
    },
    {
      label: 'Spanish',
      value: 'Spanish',
    },
    {
      label: 'French',
      value: 'French',
    },
  ];

  //to handle the onChange of language drop-down
  const changeLanguage = e => {
    i18n.changeLanguage(e.value);

    //calling UpdateUserLanguage API to save the User's selected language
    fetch(`${userInfoData.apiConfig.uiURL}api/UpdateUserLanguage`, {
      headers: APIHeader(),
      method: 'PUT',
      body: JSON.stringify({
        language: e.value,
        userId: userInfoData.userID,
      }),
    }).catch(() => {
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    });
    dispatch(
      userInfo({
        language: e.value,
      })
    );
  };

  return (
    <div>
      <CustomSelect
        value={userInfoData.language}
        onChange={changeLanguage}
        options={languageOptions}
        placeholder={userInfoData.language}
        styles={Styles}
        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
      />
    </div>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfoData: state.userInfo,
  };
};

export default connect(mapStateToProps, null)(LanguageChange);
